import React from 'react';
import MenuItem from './MenuItem';
import MenuCategory from './MenuCategory';

const CocktailsTab = ({ 
  mojitos, 
  cocktailsWithCream, 
  cocktailsWithoutCream, 
  longdrinks, 
  aperitif, 
  cocktailsNonAlcoholic 
}) => {
  return (
    <div className="space-y-16">
      {/* Mojitos */}
      <MenuCategory title="Mojitos">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {mojitos.map((cocktail) => (
            <MenuItem key={cocktail.id} item={cocktail} />
          ))}
        </div>
      </MenuCategory>

      {/* Cocktails mit Sahne */}
      <MenuCategory title="Cocktails mit Sahne">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cocktailsWithCream.map((cocktail) => (
            <MenuItem key={cocktail.id} item={cocktail} />
          ))}
        </div>
      </MenuCategory>

      {/* Cocktails ohne Sahne */}
      <MenuCategory title="Cocktails ohne Sahne">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cocktailsWithoutCream.map((cocktail) => (
            <MenuItem key={cocktail.id} item={cocktail} />
          ))}
        </div>
      </MenuCategory>

      {/* Longdrinks */}
      <MenuCategory title="Longdrinks">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {longdrinks.map((drink) => (
            <MenuItem key={drink.id} item={drink} />
          ))}
        </div>
      </MenuCategory>

      {/* Aperitif */}
      <MenuCategory title="Aperitif">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {aperitif.map((drink) => (
            <MenuItem key={drink.id} item={drink} />
          ))}
        </div>
      </MenuCategory>

      {/* Alkoholfreie Cocktails */}
      <MenuCategory title="Alkoholfreie Cocktails">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {cocktailsNonAlcoholic.map((cocktail) => (
            <MenuItem key={cocktail.id} item={cocktail} />
          ))}
        </div>
      </MenuCategory>
    </div>
  );
};

export default CocktailsTab;
